/* import __COLOCATED_TEMPLATE__ from './phone-call.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type PhoneCall from 'embercom/objects/inbox/renderable/phone-call';
import { FEATURE_FLAG_NAME } from 'embercom/lib/inbox2/event-text-truncation';

interface PhoneCallPart extends RenderablePart {
  renderableData: PhoneCall;
}

interface Signature {
  Args: {
    part: PhoneCallPart;
  };
}

export default class PhoneCallComponent extends Component<Signature> {
  @service declare session: Session;

  get translationKey() {
    let action = this.args.part.renderableData.action;

    if (action === 'start') {
      return 'inbox.phone-call.call.start';
    } else if (action === 'end') {
      return 'inbox.phone-call.call.end';
    }

    // Fallback in case of unexpected action value
    return 'inbox.phone-call.call.start';
  }

  get isConversationEventsUiImprovementsEnabled(): boolean {
    return this.session.workspace?.isFeatureEnabled(FEATURE_FLAG_NAME) ?? false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::PhoneCall': typeof PhoneCallComponent;
    'inbox2/conversation-stream/event-parts/phone-call': typeof PhoneCallComponent;
  }
}
